import { createStore, combineReducers } from 'redux';
import { tablesReducer } from './reducers/tablesReducer';
import { tablePreviewReducer } from './reducers/tablePreviewReducer';
import { previewImportReducer } from './reducers/previewImportReducer';
const rootReducer = combineReducers({
  tables: tablesReducer,
  tablePreview: tablePreviewReducer,
  previewImport: previewImportReducer,
});

export const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);